import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Snackbar } from 'react-native-paper';
import { MainColors } from '../constants/Colors';

const CustomSnackbar = (props) => {
    return (
        <View style={styles.container}>
            <Snackbar
                duration={2500}
                style={{ backgroundColor: MainColors.secondary }}
                visible={props.visible}
                onDismiss={props.onDismiss}
                theme={{ colors: { accent: 'white' } }}
                action={{
                    label: props.actionLabel,
                    onPress: props.actionOnPress
                }}
            >
                {props.message}
            </Snackbar>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'space-between'
    },
});

export default CustomSnackbar;